var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 49,
    viewBox: "0 0 24 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 2C13.5 1.17157 12.8284 0.5 12 0.5C11.1716 0.5 10.5 1.17157 10.5 2L13.5 2ZM10.9393 48.0607C11.5251 48.6464 12.4749 48.6464 13.0607 48.0607L22.6066 38.5147C23.1924 37.9289 23.1924 36.9792 22.6066 36.3934C22.0208 35.8076 21.0711 35.8076 20.4853 36.3934L12 44.8787L3.51472 36.3934C2.92893 35.8076 1.97918 35.8076 1.3934 36.3934C0.80761 36.9792 0.80761 37.9289 1.3934 38.5147L10.9393 48.0607ZM10.5 2L10.5 47L13.5 47L13.5 2L10.5 2Z",
    fill: "#FFA842"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.414345488443c6c4b689de1b8ed285fc.svg";
export { ForwardRef as ReactComponent };